import { render, staticRenderFns } from "./territorialUnitPage.vue?vue&type=template&id=de04f47c&"
import script from "./territorialUnitPage.vue?vue&type=script&lang=js&"
export * from "./territorialUnitPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports